import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

jQuery(function ($) {
	if ($('.quants').length) {
		gsap.registerPlugin(ScrollTrigger);

		function animateQuant(el) {
			if (!$(el).hasClass('animated')) {
				$(el).find('.quant').prop('Counter', 0).animate({
					Counter: $(el).find('.quant').data('number')
				}, {
					duration: 1000,
					easing: 'swing',
					step: function (now) {
						$(this).text(Math.ceil(now));
					}
				});

				$(el).addClass('animated');
			}
		}

		let trigger = gsap.utils.toArray('.quant-wrapper');

		trigger.forEach((element) => {
			gsap.timeline({
				scrollTrigger: {
					trigger: element,
					start: 'bottom bottom',
					onEnter: function () {
						animateQuant(element);
					},
					markers: false,
				}
			});
		});
	}
});
